import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { ConfirmationModal, useOverlayContext } from 'seagull';
import { useLocaleKeys } from '~/i18n';
import { handlePromise } from '~/infra/utils';
export default function VendorAccountantAccessModal(props) {
    const { failureToastProps, onSuccess, onSubmit, dismissModal } = props, rest = _object_without_properties(props, [
        "failureToastProps",
        "onSuccess",
        "onSubmit",
        "dismissModal"
    ]);
    const { t: commonTexts } = useLocaleKeys('common');
    const overlayContext = useOverlayContext();
    const [loading, setLoading] = useState(false);
    async function onPrimaryButtonClick() {
        setLoading(true);
        const { success } = await handlePromise(onSubmit());
        if (success) {
            await onSuccess();
        } else if (failureToastProps) {
            overlayContext.showErrorToast(failureToastProps.text, failureToastProps.testId);
        }
        setLoading(false);
        dismissModal();
    }
    return /*#__PURE__*/ _jsx(ConfirmationModal, _object_spread({
        bi: {
            primaryButton: {
                name: 'vendor_accountant_access_confirm'
            },
            secondaryButton: {
                name: 'vendor_accountant_access_cancel'
            }
        },
        textAlignCenter: false,
        secondaryButtonLabel: commonTexts.buttons.cancel(),
        onCloseButtonClick: dismissModal,
        onSecondaryButtonClick: dismissModal,
        onPrimaryButtonClick: onPrimaryButtonClick,
        primaryButtonLoading: loading
    }, rest));
}
